import useDiscountOnly from '@discover-data/stores/hooks/discountOnly/useDiscountOnly';
import Toggle, { ToggleProps } from '@discover-ui/toggle';

export type DiscountOnlyToggleProps = Omit<
  ToggleProps,
  'pressed' | 'onPressedChange' | 'aria-label' | 'children'
>;

export default function DiscountOnlyToggle({ className, ...props }: DiscountOnlyToggleProps) {
  const [discountOnlyStoreValue, setDiscountOnly] = useDiscountOnly();

  return (
    <Toggle
      pressed={discountOnlyStoreValue}
      onPressedChange={setDiscountOnly}
      aria-label="50% off only"
      className={className}
      {...props}>
      50% off
    </Toggle>
  );
}
